import { FC } from "react";

import { Typography } from "@/shared/ui";

import styles from "./last-node-message.module.scss";

const LastNodeMessage: FC = ({}) => {
  return (
    <div className={styles.lastNodeMessage}>
      <span className={styles.dot} />
      <div className={styles.panel}>
        <Typography align="center" variant="footnote">
          There are no more users that fit your search. You may try to expand filters.
        </Typography>
      </div>
    </div>
  );
};

export { LastNodeMessage };
